if (!customElements.get('product-testimonials-metaobjects')) {
  customElements.define(
    'product-testimonials-metaobjects',
    class ProductTestimonialsMetaobjects extends HTMLElement {
      connectedCallback() {
        this.renderFlags();
      }

      renderFlags() {
        const authors = this.querySelectorAll('.product-testimonials-card__author');

        authors.forEach((author) => {
          if (!author || author.dataset.flagsWrapped === 'true') return;

          const originalText = (author.textContent || '').trim();
          if (!originalText) {
            author.dataset.flagsWrapped = 'true';
            return;
          }

          author.innerHTML = this.replaceCountryCodesWithFlags(originalText);
          author.dataset.flagsWrapped = 'true';
        });
      }

      replaceCountryCodesWithFlags(text) {
        const existingFlagRegex = /([\u{1F1E6}-\u{1F1FF}]{2})/gu;
        const countryCodeRegex = /(^|[\s(])([a-z]{2})(?=$|[\s),./-])/giu;

        let result = text.replace(existingFlagRegex, (match) => {
          const code = this.flagToCountryCode(match);
          if (!code) {
            return `<span class="product-testimonials-card__emoji-flag">${match}</span>`;
          }

          return this.buildFlagImage(code);
        });

        result = result.replace(countryCodeRegex, (match, prefix, code) => {
          const normalized = this.normalizeCountryCode(code);
          if (!normalized) return match;
          return `${prefix}${this.buildFlagImage(normalized)}`;
        });

        return result;
      }

      normalizeCountryCode(code) {
        if (!code || code.length !== 2) return '';

        const normalized = code.toUpperCase();
        if (!/^[A-Z]{2}$/.test(normalized)) return '';

        return normalized;
      }

      flagToCountryCode(flag) {
        if (!flag || [...flag].length !== 2) return '';

        const chars = [...flag];
        const first = chars[0].codePointAt(0) - 127397;
        const second = chars[1].codePointAt(0) - 127397;

        if (first < 65 || first > 90 || second < 65 || second > 90) return '';

        return String.fromCharCode(first, second);
      }

      buildFlagImage(code) {
        const normalized = this.normalizeCountryCode(code);
        if (!normalized) return '';

        const countryCode = normalized.toLowerCase();
        return `<img class="product-testimonials-card__flag-image" src="https://flagcdn.com/24x18/${countryCode}.png" srcset="https://flagcdn.com/48x36/${countryCode}.png 2x" width="12" height="9" loading="lazy" alt="${normalized}">`;
      }
    }
  );
}
